import { Fragment, ReactElement, useCallback, useEffect, useRef, useState } from 'react'
import Button from '../components/Button'
import { Checkbox, States as CheckboxStates } from '../components/Checkbox'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import Menu from '../components/Menu/Menu'
import useTranslation from '../Hooks/useTranslation'
import moment from 'moment'
import DatePicker, { registerLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import '../scss/datepicker.scss'
import { AppWriteContext } from '../Contexts/AppWriteContext'
// import { useTranslation } from "react-i18next"
import usePrefStore from '../stores/prefs'
// import useModelsStore from '../stores/models';
import styles from './Params.module.scss'
// import useTarifs from '../Hooks/useTarifs';
import SegmentedButtons from '../components/SegmentedButtons'
import InputField from '../components/InputField'
import useHelpers from '../Hooks/useHelpers'
import useIsSingleCustomerLocal from '../Hooks/useIsSingleCustomerLocal'
// import useSales from '../Hooks/useSales';
import { useNavigate } from 'react-router-dom'

registerLocale('fr', fr)
// import { useLogger } from '../Contexts/Logger';
// import { db } from "../stores/db"

// const secretPhrase = 'run forest run'

function Params() {
   const fontsCacheName = 'fonts'
   const collectionsCacheName = 'collections'
   const productsCacheName = 'products'
   // Prefs store
   // // const logToServer = usePrefStore((state) => state.logToServer);
   // // const setLogToServer = usePrefStore((state) => state.setLogToServer);
   // // const logToConsole = usePrefStore((state) => state.logToConsole);
   // // const setLogToConsole = usePrefStore((state) => state.setLogToConsole);
   // // const setFilterDelay = usePrefStore((state) => state.setFilterDelay);
   // const resetPrefs = usePrefStore((state) => state.reset);
   // const catalogMainAlign = usePrefStore((state) => state.catalogMainAlign);
   // const setCatalogMainAlign = usePrefStore((state) => state.setCatalogMainAlign);
   // const globalClosePopups = usePrefStore((state) => state.globalClosePopups);
   // const setGlobalClosePopups = usePrefStore((state) => state.setGlobalClosePopups);
   // const debug = usePrefStore((state) => state.debug);
   // const setDebug = usePrefStore((state) => state.setDebug);
   // const localOrderId = usePrefStore((state) => state.localOrderId);
   // const setLocalOrderId = usePrefStore((state) => state.setLocalOrderId);
   // const maxTarifsOffline = usePrefStore((state) => state.maxTarifsOffline);
   // const setMaxTarifsOffline = usePrefStore((state) => state.setMaxTarifsOffline);
   // const qtyMaxOrder = usePrefStore((state) => state.qtyMaxOrder);
   // const setQtyMaxOrder = usePrefStore((state) => state.setQtyMaxOrder);
   // const showWeeksNum = usePrefStore((state) => state.showWeeksNum);
   // const setShowWeeksNum = usePrefStore((state) => state.setShowWeeksNum);
   // const minFilterLength = usePrefStore((state) => state.minFilterLength);
   // const setMinFilterLength = usePrefStore((state) => state.setMinFilterLength);
   // const noScrollbars = usePrefStore((state) => state.noScrollbars);
   // const setNoScrollbars = usePrefStore((state) => state.setNoScrollbars);
   // const imgSourcePrio = usePrefStore((state) => state.imgSourcePrio);
   // const setImgSourcePrio = usePrefStore((state) => state.setImgSourcePrio);
   // const timeFormat = usePrefStore((state) => state.timeFormat);
   // const setTimeFormat = usePrefStore((state) => state.setTimeFormat);
   // const dateFormat = usePrefStore((state) => state.dateFormat);
   // const setDateFormat = usePrefStore((state) => state.setDateFormat);
   const listPageLength = Number(usePrefStore((state) => state.listPageLength))
   // const setListPageLength = usePrefStore((state) => state.setListPageLength);
   // const maxPageButtonsOnLists = usePrefStore((state) => state.maxPageButtonsOnLists);
   // const setMaxPageButtonsOnLists = usePrefStore((state) => state.setMaxPageButtonsOnLists);
   // const showImageSource = usePrefStore((state) => state.showImageSource);
   // const setShowImageSource = usePrefStore((state) => state.setShowImageSource);
   // const formatPhone = usePrefStore((state) => state.formatPhone);
   // const setFormatPhone = usePrefStore((state) => state.setFormatPhone);
   // const maxRecentItems = usePrefStore((state) => state.maxRecentItems);
   // const setMaxRecentItems = usePrefStore((state) => state.setMaxRecentItems);
   // const showCessDelay = usePrefStore((state) => state.showCessDelay);
   // const setShowCessDelay = usePrefStore((state) => state.setShowCessDelay);
   // const keepHistoryOpen = usePrefStore((state) => state.keepHistoryOpen);
   // const setKeepHistoryOpen = usePrefStore((state) => state.setKeepHistoryOpen);
   const {
      reset: resetPrefs,
      catalogMainAlign,
      setCatalogMainAlign,
      globalClosePopups,
      setGlobalClosePopups,
      debug,
      setDebug,
      screenshotMode,
      setScreenshotMode,
      localOrderId,
      setLocalOrderId,
      maxTarifsOffline,
      setMaxTarifsOffline,
      qtyMaxOrder,
      setQtyMaxOrder,
      showWeeksNum,
      setShowWeeksNum,
      minFilterLength,
      setMinFilterLength,
      noScrollbars,
      setNoScrollbars,
      imgSourcePrio,
      setImgSourcePrio,
      timeFormat,
      setTimeFormat,
      dateFormat,
      setDateFormat,
      setListPageLength,
      maxPageButtonsOnLists,
      setMaxPageButtonsOnLists,
      showImageSource,
      setShowImageSource,
      formatPhone,
      setFormatPhone,
      maxRecentItems,
      setMaxRecentItems,
      showCessDelay,
      setShowCessDelay,
      keepHistoryOpen,
      setKeepHistoryOpen,
      sessionDuration,
      setSessionDuration,
      theme,
      setTheme,
      showThemeToggle,
      setShowThemeToggle,
      showTests,
      setShowTests,
      isRetailManager,
      absenceFrom,
      absenceTo,
      currentLang,
   } = usePrefStore()
   const { setUserAbsence } = AppWriteContext() as any
   const [absFromInput, setAbsFromInput] = useState<string>(absenceFrom ?? '')
   const [absToInput, setAbsToInput] = useState<string>(absenceTo ?? '')
   const [absSaving, setAbsSaving] = useState(false)
   useEffect(() => { setAbsFromInput(absenceFrom ?? '') }, [absenceFrom])
   useEffect(() => { setAbsToInput(absenceTo ?? '') }, [absenceTo])
   const absDirty = (absFromInput || '') !== (absenceFrom ?? '') || (absToInput || '') !== (absenceTo ?? '')
   const absInvalid = (!!absFromInput !== !!absToInput)
      || (absFromInput && absToInput && absFromInput > absToInput)
   const onSaveAbsence = async () => {
      if (absInvalid) return
      setAbsSaving(true)
      await setUserAbsence(absFromInput || null, absToInput || null)
      setAbsSaving(false)
   }
   const onClearAbsence = async () => {
      setAbsSaving(true)
      await setUserAbsence(null, null)
      setAbsSaving(false)
   }
   //
   const [showExpert, setShowExpert] = useState(false)
   // Verrou du bouton "Passer en mode Expert". Il faut taper 5 fois dans l'entête
   // en moins de 2 secondes pour le déverrouiller. Le retour en mode Normal (via
   // le bouton) referme le verrou. Le bouton reste toujours affiché pour signaler
   // son existence, mais est disabled tant que le verrou est fermé.
   const EXPERT_UNLOCK_TAPS = 5
   const EXPERT_UNLOCK_WINDOW_MS = 2000
   const [unlockTaps, setUnlockTaps] = useState(0)
   const [isExpertUnlocked, setIsExpertUnlocked] = useState(false)
   const unlockWindowTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
   const clearUnlockWindow = () => {
      if (unlockWindowTimerRef.current) {
         clearTimeout(unlockWindowTimerRef.current)
         unlockWindowTimerRef.current = null
      }
   }
   const onHeaderTap = () => {
      if (isExpertUnlocked) return
      const next = unlockTaps + 1
      if (next >= EXPERT_UNLOCK_TAPS) {
         clearUnlockWindow()
         setUnlockTaps(0)
         setIsExpertUnlocked(true)
      } else {
         setUnlockTaps(next)
         if (!unlockWindowTimerRef.current) {
            unlockWindowTimerRef.current = setTimeout(() => {
               unlockWindowTimerRef.current = null
               setUnlockTaps(0)
            }, EXPERT_UNLOCK_WINDOW_MS)
         }
      }
   }
   useEffect(() => clearUnlockWindow, [])
   // const [secret, setSecret] = useState('');  // Un code "secret" pour autoriser qq actions dangereuses
   const [cachesInfo, setCachesInfo] = useState({ fonts: { count: 0, bytes: 0 }, collections: { count: 0, bytes: 0 }, products: { count: 0, bytes: 0 } })
   const [segPrioImages, setSegPrioImages] = useState<ReactElement | null>(null)
   const [segPosCatalog, setSegPosCatalog] = useState<ReactElement | null>(null)
   const [segClosePopups, setSegClosePopups] = useState<ReactElement | null>(null)
   // const [segSliderPrice, setSegSliderPrice] = useState(null)
   const [segTimeFormat, setSegTimeFormat] = useState<ReactElement | null>(null)
   const [segDateFormat, setSegDateFormat] = useState<ReactElement | null>(null)
   const [segListPageLength, setSegListPageLength] = useState<ReactElement | null>(null)
   const [segSessionDuration, setSegSessionDuration] = useState<ReactElement | null>(null)
   const [segMaxPageButtonsOnLists, setSegMaxPageButtonsOnLists] = useState<ReactElement | null>(null)
   const [tmpMaxRecentItems, setTmpMaxRecentItems] = useState<number | null>(null) // Juste le temps de l'édition
   //
   // const { fetchOrders } = useSales()
   //
   const { trans } = useTranslation()
   const { getVersion, getVersionDate, getCopyright, getDevRef } = useHelpers()
   const navigate = useNavigate()
   // Mode "1 seul client local" : pas de gestion des tarifs offline (le tarif
   // unique est verrouillé sur celui du client).
   const isSingleCustomer = useIsSingleCustomerLocal()
   // const { log } = useLogger();

   const calcAllCachesInfo = useCallback(async () => {
      try {
         const [fonts, collections, products] = await Promise.all([getCacheInfo(fontsCacheName), getCacheInfo(collectionsCacheName), getCacheInfo(productsCacheName)])
         setCachesInfo({ fonts, collections, products })
      } catch {
         console.log('Pas de cache!!!')
      }
   }, [])

   useEffect(() => {
      calcAllCachesInfo()
   }, [calcAllCachesInfo])

   useEffect(() => {
      setTmpMaxRecentItems(maxRecentItems)
   }, [maxRecentItems])

   function formatBytes(bytes: number): string {
      if (bytes === 0) return ''
      if (bytes < 1024) return `${bytes} o`
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`
      return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`
   }

   async function getCacheInfo(cacheName: string) {
      try {
         const cache = await caches.open(cacheName)
         const keys = await cache.keys()
         let bytes = 0
         for (const req of keys) {
            const response = await cache.match(req)
            const cl = response?.headers.get('Content-Length')
            if (cl) bytes += parseInt(cl, 10)
         }
         return { count: keys.length, bytes }
      } catch {
         return { count: 0, bytes: 0 }
      }
   }

   async function cleanOneCache(cacheName: string) {
      console.log('Suppression du cache', cacheName)
      await caches.delete(cacheName)
      await calcAllCachesInfo()
   }

   function doResetPrefs() {
      resetPrefs()
   }

   function doResetPrefsAndUdid() {
      resetPrefs({ regenerateUdid: true })
   }

   function toggleExpert() {
      if (showExpert) {
         // Retour en mode Normal : on referme le verrou
         setShowExpert(false)
         setIsExpertUnlocked(false)
      } else {
         setShowExpert(true)
      }
   }

   const onCatalogMainAlignChange = useCallback(
      (val) => {
         setCatalogMainAlign(val)
      },
      [setCatalogMainAlign]
   )

   const onGlobalClosePopupsChange = useCallback(
      (val) => {
         // console.log(val)
         setGlobalClosePopups(val)
      },
      [setGlobalClosePopups]
   )

   function onMinFilterLengthChange(val) {
      setMinFilterLength(val)
   }

   // function onFilterDelayChange(val) {
   //    setFilterDelay(val);
   // }

   const onListPageLengthChange = useCallback(
      (val) => {
         setListPageLength(val)
      },
      [setListPageLength]
   )

   const onSessionDurationChange = useCallback(
      (val) => {
         setSessionDuration(val)
      },
      [setSessionDuration]
   )

   const onImgSourcePrioChange = useCallback(
      (val) => {
         setImgSourcePrio(val)
      },
      [setImgSourcePrio]
   )

   const onTimeFormatChange = useCallback(
      (val) => {
         setTimeFormat(val)
      },
      [setTimeFormat]
   )

   const onDateFormatChange = useCallback(
      (val) => {
         setDateFormat(val)
      },
      [setDateFormat]
   )

   const onMaxPageButtonsOnListsChange = useCallback(
      (val) => {
         setMaxPageButtonsOnLists(val)
      },
      [setMaxPageButtonsOnLists]
   )

   const onLocalOrderIdChange = useCallback(
      (val) => {
         setLocalOrderId(val)
      },
      [setLocalOrderId]
   )

   const onQtyMaxOrderChange = useCallback(
      (val) => {
         setQtyMaxOrder(val)
      },
      [setQtyMaxOrder]
   )

   // const onSecretChange = useCallback((val) => {
   //    setSecret(val);
   // }, [setSecret]);

   // const doCleanOrders = useCallback((val) => {
   //    db.orders.clear()
   //    fetchOrders()
   // }, [fetchOrders]);

   useEffect(() => {
      const segments = [
         { value: 'bymessika', label: trans('?by Messika') },
         { value: 'internal', label: trans('?Interne') }
      ]

      setSegPrioImages(<SegmentedButtons segments={segments} default={imgSourcePrio} medium_padding opaque onChange={onImgSourcePrioChange} />)
   }, [imgSourcePrio, onImgSourcePrioChange, trans])

   useEffect(() => {
      const segments = [
         { value: 'left', label: trans('?Gauche') },
         { value: 'center', label: trans('?Centré') }
      ]
      setSegPosCatalog(<SegmentedButtons segments={segments} default={catalogMainAlign} medium_padding opaque onChange={onCatalogMainAlignChange} />)
   }, [catalogMainAlign, onCatalogMainAlignChange, trans])

   useEffect(() => {
      const segments = [
         { value: 'button', label: trans('?Bouton seulement') },
         { value: 'all', label: trans('?Partout') }
      ]

      setSegClosePopups(<SegmentedButtons segments={segments} name="orderby" medium_padding opaque default={globalClosePopups} onChange={onGlobalClosePopupsChange} />)
   }, [globalClosePopups, onGlobalClosePopupsChange, trans])

   useEffect(() => {
      const segments = [
         { value: '24', label: '24H' },
         { value: '12', label: '12H AM/PM' }
      ]

      setSegTimeFormat(<SegmentedButtons segments={segments} name="orderby" medium_padding default={timeFormat} opaque onChange={onTimeFormatChange} />)
   }, [onTimeFormatChange, timeFormat])

   useEffect(() => {
      const segments = [
         { value: 'dmy', label: trans('?DD-MM-YYYY') },
         { value: 'mdy', label: trans('?MM-DD-YYYY') },
         { value: 'ymd', label: trans('?YYYY-MM-DD') },
         { value: 'ydm', label: trans('?YYYY-DD-MM') }
      ]

      setSegDateFormat(<SegmentedButtons segments={segments} name="orderby" medium_padding default={dateFormat} opaque onChange={onDateFormatChange} />)
   }, [onDateFormatChange, dateFormat, trans])

   useEffect(() => {
      const segments = [
         { value: '10', label: '10' },
         { value: '20', label: '20' },
         { value: '50', label: '50' },
         { value: '100', label: '100' },
         { value: '999999', label: 'Tous' }
      ]

      setSegListPageLength(<SegmentedButtons segments={segments} name="orderby" medium_padding default={String(listPageLength)} opaque onChange={onListPageLengthChange} />)
   }, [onListPageLengthChange, listPageLength])

   useEffect(() => {
      const segments = [
         { value: '600', label: '10 min' },
         { value: '1800', label: '30 min' },
         { value: '3600', label: '1 H' },
         { value: '14400', label: '4 H' },
         { value: '86400', label: '1 J' },
         { value: '31536000', label: 'Sans limite' }
      ]

      setSegSessionDuration(<SegmentedButtons segments={segments} name="orderby" medium_padding default={String(sessionDuration)} opaque onChange={onSessionDurationChange} />)
   }, [onSessionDurationChange, sessionDuration])

   useEffect(() => {
      const segments = [
         { value: 3, label: '3' },
         { value: 5, label: '5' },
         { value: 10, label: '10' }
      ]

      setSegMaxPageButtonsOnLists(<SegmentedButtons segments={segments} name="orderby" medium_padding default={maxPageButtonsOnLists} opaque onChange={onMaxPageButtonsOnListsChange} />)
   }, [onMaxPageButtonsOnListsChange, maxPageButtonsOnLists])

   function onChangeMaxRecentItems(val) {
      if (val > 0) {
         // Pour pouvoir supprimer complètement le champ de saisi, sinon ça revient auto à la valeur par défaut (5)
         setMaxRecentItems(val)
      } else {
         setTmpMaxRecentItems(val)
      }
   }

   // console.log('SEGS0', segMaxPageButtonsOnLists)

   return (
      <Fragment>
         <Menu page="params" />
         <div className={`${styles.params} ${noScrollbars ? '' : styles.noscrollbars}`}>
            <div className={styles.innerbox}>
               <div onClick={onHeaderTap}>
                  <Button small onClick={() => navigate(-1)}>
                     {trans('?Retour')}
                  </Button>
                  <Button small onClick={toggleExpert} disabled={!isExpertUnlocked} inactive={!isExpertUnlocked} tertiary={!isExpertUnlocked}>
                     {showExpert ? trans('?Repasser en mode Normal') : trans('?Passer en mode Expert')}
                  </Button>
               </div>
               {showExpert && <h3>{trans('?warn_expert_mode')}</h3>}
               {!showExpert && <>
                  {isRetailManager && (
                     <>
                        <h1>{trans("?Période d'absence")}</h1>
                        <section className={styles.absence}>
                           <div>
                              <label>{trans('?du')}</label>
                              <DatePicker
                                 selected={absFromInput ? moment(absFromInput).toDate() : null}
                                 onChange={(d: Date | null) => setAbsFromInput(d ? moment(d).format('YYYY-MM-DD') : '')}
                                 dateFormat="dd/MM/yyyy"
                                 locale={currentLang === 'fr' ? 'fr' : 'en-US'}
                                 showWeekNumbers={showWeeksNum}
                                 calendarStartDay={1}
                                 placeholderText="JJ/MM/AAAA"
                                 className={styles.date_input}
                              />
                              <label>{trans('?au')}</label>
                              <DatePicker
                                 selected={absToInput ? moment(absToInput).toDate() : null}
                                 onChange={(d: Date | null) => setAbsToInput(d ? moment(d).format('YYYY-MM-DD') : '')}
                                 dateFormat="dd/MM/yyyy"
                                 locale={currentLang === 'fr' ? 'fr' : 'en-US'}
                                 showWeekNumbers={showWeeksNum}
                                 calendarStartDay={1}
                                 minDate={absFromInput ? moment(absFromInput).toDate() : undefined}
                                 placeholderText="JJ/MM/AAAA"
                                 className={styles.date_input}
                              />
                              <span className={styles.absence_inclus}>{trans('?inclus')}</span>
                           </div>
                           {absInvalid && (
                              <div className={styles.absence_warn}>{trans('?Les deux dates sont obligatoires et "du" doit être avant ou égal à "au".')}</div>
                           )}
                           {absenceFrom && absenceTo && !absDirty && (
                              <div className={styles.absence_status}>
                                 {trans('?Absence enregistrée : du')} <span className={styles.absence_date_pill}>{moment(absenceFrom).format('dddd DD/MM/YYYY')}</span> {trans('?au')} <span className={styles.absence_date_pill}>{moment(absenceTo).format('dddd DD/MM/YYYY')}</span> ({trans('?inclus')})
                              </div>
                           )}
                           <div>
                              <Button small onClick={onSaveAbsence} disabled={!absDirty || !!absInvalid || absSaving}>{trans('?Enregistrer')}</Button>
                              <Button small secondary onClick={onClearAbsence} disabled={(!absenceFrom && !absenceTo) || absSaving}>{trans('?Effacer')}</Button>
                           </div>
                        </section>
                     </>
                  )}
                  <h1>{trans('?Paramètres régionaux')}</h1>
                  <section className={styles.region}>
                     <div>
                        {trans("?Format d'heure")}
                        {segTimeFormat}
                     </div>
                     <div>
                        {trans('?Format de date')}
                        {segDateFormat}
                     </div>
                  </section>
                  <h1>{trans('?Interface')}</h1>
                  <section className={styles.gui}>
                     <Checkbox caption={trans('?Afficher ascenseurs')} checked={`${!noScrollbars ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setNoScrollbars(status !== CheckboxStates.Checked)} />
                     <Checkbox caption={trans('?Thème alternatif (test couleurs)')} checked={`${theme === 'alt' ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setTheme(status === CheckboxStates.Checked ? 'alt' : 'default')} />
                     <Checkbox caption={trans('?Afficher le toggle de thème global')} checked={`${showThemeToggle ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setShowThemeToggle(status === CheckboxStates.Checked)} />
                     <div>
                        {trans('?Position catalogue')}
                        {segPosCatalog}
                     </div>
                     <div>
                        {trans('?max_buttons_on_lists')}
                        {segMaxPageButtonsOnLists}
                     </div>
                  </section>
               </>}
               {showExpert && <>
               <h1>{trans('?Global')}</h1>
               <section className={styles.global}>
                  <div>
                     {trans('?N° de commande')}
                     <div style={{ width: 100 }}>
                        <InputField placeholder="3" value={localOrderId} onChange={onLocalOrderIdChange}></InputField>
                     </div>
                  </div>
                  <div>
                     {trans('?Quantité maxi par ligne de commande')}
                     <div style={{ width: 60 }}>
                        <InputField placeholder="3" value={qtyMaxOrder} onChange={onQtyMaxOrderChange}></InputField>
                     </div>
                  </div>
                  {!isSingleCustomer && (
                     <div>
                        {trans('?max_tarifs_offline')}
                        <div style={{ width: 60 }}>
                           <InputField placeholder="3" value={maxTarifsOffline} onChange={(evt) => setMaxTarifsOffline(evt.target.value)}></InputField>
                        </div>
                     </div>
                  )}
                  {/* {showExpert && (
                     <div>
                        <div style={{ width: 200 }}>
                           <InputField placeholder="secret" value={secret} password onChange={onSecretChange} ></InputField>
                        </div>
                        <div>
                           <Button small onClick={doCleanOrders} inactive={secret !== secretPhrase} tertiary={secret !== secretPhrase}>
                              <FontAwesomeIcon icon={faTriangleExclamation} />
                              <FontAwesomeIcon icon={faTriangleExclamation} />
                              {trans('?Supprimer toutes les commandes')}
                              <FontAwesomeIcon icon={faTriangleExclamation} />
                              <FontAwesomeIcon icon={faTriangleExclamation} />
                           </Button>
                        </div>
                     </div>
                  )} */}
               </section>
               <h1>{trans('?Interface')}</h1>
               <section className={styles.gui}>
                  <div>
                     {trans('?Priorité des images')}
                     {segPrioImages}
                  </div>
                  <Checkbox caption={trans('?Afficher puce pour byMessika')} checked={`${showImageSource ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setShowImageSource(status === CheckboxStates.Checked)} />
                  <Checkbox caption={trans('?Formater numéros de téléphone')} checked={`${formatPhone ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setFormatPhone(status === CheckboxStates.Checked)} />
                  <Checkbox caption={trans('?Afficher les numéros de semaine (date picker)')} checked={`${showWeeksNum ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setShowWeeksNum(status === CheckboxStates.Checked)} />
                  <div>
                     {trans('?history_size')}
                     <div style={{ width: 60 }}>
                        <InputField placeholder="3" value={tmpMaxRecentItems} onChange={(val) => onChangeMaxRecentItems(val)}></InputField>
                     </div>
                  </div>
                  <Checkbox caption={trans('?Garder historique ouvert')} checked={`${keepHistoryOpen ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setKeepHistoryOpen(status === CheckboxStates.Checked)} />
                  <div>
                     {trans('?Fermeture popups')}
                     {segClosePopups}
                  </div>
                  {/* <div>
                     {trans("?Borneur de prix")}{segSliderPrice}
                  </div> */}
                  <div>
                     {trans('?min_length')}
                     <div style={{ width: 50 }}>
                        <InputField placeholder="3" value={minFilterLength} onChange={onMinFilterLengthChange}></InputField>
                     </div>
                  </div>
                  <div>
                     {trans('?delay_show_cess')}
                     <div style={{ width: 80 }}>
                        <InputField placeholder="3" value={showCessDelay} onChange={(val) => setShowCessDelay(val)}></InputField>
                     </div>
                  </div>
                  <div>
                     {trans("?Durée maxi d'inactivité")}
                     {segSessionDuration}
                  </div>
                  <div>
                     {trans('?list_length_per_page')}
                     {segListPageLength}
                  </div>
                  {showExpert && (
                     <>
                        <Button small onClick={doResetPrefs}>
                           {trans('?Réinitialiser les préférences')}
                        </Button>
                        <Button small onClick={doResetPrefsAndUdid}>
                           {trans('?Réinitialiser + nouvel udid')}
                        </Button>
                        <Button small onClick={() => cleanOneCache(collectionsCacheName)}>
                           {trans('?Purger le cache')} "{trans('?Images clés')}" ({cachesInfo.collections.count}
                           {cachesInfo.collections.bytes > 0 ? ` • ${formatBytes(cachesInfo.collections.bytes)}` : ''})
                        </Button>
                        <Button small onClick={() => cleanOneCache(productsCacheName)}>
                           {trans('?Purger le cache')} "{trans('?Images modèles')}" ({cachesInfo.products.count}
                           {cachesInfo.products.bytes > 0 ? ` • ${formatBytes(cachesInfo.products.bytes)}` : ''})
                        </Button>
                        <Button small onClick={() => cleanOneCache(fontsCacheName)}>
                           {trans('?Purger le cache')} "fonts" ({cachesInfo.fonts.count}
                           {cachesInfo.fonts.bytes > 0 ? ` • ${formatBytes(cachesInfo.fonts.bytes)}` : ''})
                        </Button>
                        <Checkbox caption="Debug" checked={`${debug ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setDebug(status === CheckboxStates.Checked)} />
                        {/* Mode screenshots : disponible uniquement quand Debug est ON.
                            Masque le bloc debug dans le Menu tout en gardant l'override
                            de rôle actif (utile pour des captures propres). */}
                        {debug && (
                           <Checkbox caption="Mode screenshots" checked={`${screenshotMode ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setScreenshotMode(status === CheckboxStates.Checked)} />
                        )}
                        <Checkbox caption="Test" checked={`${showTests ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setShowTests(status === CheckboxStates.Checked)} />
                        {/* <Checkbox caption="Log server" checked={`${logToServer ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setLogToServer(status === CheckboxStates.Checked)}/> */}
                        {/* <Checkbox caption="Log console" checked={`${logToConsole ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={(status) => setLogToConsole(status === CheckboxStates.Checked)} /> */}
                     </>
                  )}
               </section>
               </>}
            </div>
            <div className={styles.footer}>
               <span>
                  Version : {getVersion()} ({getVersionDate()}) - {getCopyright()}
               </span>
               <span>{getDevRef()}</span>
            </div>
         </div>
      </Fragment>
   )
}

export default Params
